import React from 'react';
import { Row, Col, Button } from 'antd';
import { faCheckCircle, faExclamationCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import I18n from '@src/i18n';
import styled from '@src/styled-components';

interface IProp {
  component: any,
  process: any
}

function ResultIcon ({ recognized, min, max }: any) {
  if(Number(recognized) === 0)
    return <Icon icon={faTimesCircle} className='error' />
  
  if (Number(recognized) < Number(min) || Number(recognized) > Number(max))
    return <Icon icon={faExclamationCircle} className='warning' />
  
  if (Number(recognized) >= Number(min) && Number(recognized) <= Number(max))
    return <Icon icon={faCheckCircle} className='success' />
  return <></>
}

class SampleImageRecognitionComponent extends React.Component<IProp, any> {
  constructor(props: IProp) {
    super(props)

    this.getProcessComponent = this.getProcessComponent.bind(this)
  }

  getProcessComponent () {
    const { component, process } = this.props
    let allComponents: Array<any> = []

    process.sections.forEach((r: any) => {
      allComponents = [...allComponents, ...r.components]
    })

    return allComponents.find((r: any) => r.id === component.id)
  }

  render(): JSX.Element {
    const { component } = this.props
    const processComponent = this.getProcessComponent()
    return component.value.map((v: any, vIndex: any) => (<>
      {v.path && <Row key={'img-rec-path'+vIndex}>
        <Col>
          <Button href={v.path} target="_blank" type="link" style={ {paddingLeft: 0, paddingRight: 0} }>{I18n.l('history.viewImage')}</Button>
        </Col>
      </Row>}
      {v.recognitionInputs &&
      <RowStyled key={'img-rec-labels'+vIndex}>
        <Col span={14}><strong>Ítens</strong></Col>
        <Col span={5} className="text-center"><strong>Machine Learning</strong></Col>
        <Col span={5} className="text-center"><strong>{I18n.l('history.amendedAmount')}</strong></Col>
      </RowStyled>}
      
      {v.recognitionInputs && v.recognitionInputs.map((r: any, rIndex: any) => (
        <RowStyled key={'img-rec-results'+vIndex+rIndex}>
          <Col span={14}>{processComponent && processComponent.configurationItems[rIndex].name}</Col>
          <Col span={5} className="text-center">
            <ResultIcon recognized={v.recognitionInputs[rIndex]} min={processComponent.configurationItems[rIndex].quantityMin} max={processComponent.configurationItems[rIndex].quantityMax} />
            <span className="value">{v.recognitionInputs[rIndex]}/{processComponent && `${processComponent.configurationItems[rIndex].quantityMin} - ${processComponent.configurationItems[rIndex].quantityMax}`}</span>
          </Col>
          <Col span={5} className="text-center">
            <ResultIcon recognized={v.userInputs[rIndex]} min={processComponent.configurationItems[rIndex].quantityMin} max={processComponent.configurationItems[rIndex].quantityMax} />
            <span className="value">{v.userInputs[rIndex]}/{processComponent && `${processComponent.configurationItems[rIndex].quantityMin} - ${processComponent.configurationItems[rIndex].quantityMax}`}</span>
          </Col>
        </RowStyled>
      ))}
    </>))
  }
};

export default SampleImageRecognitionComponent;

const RowStyled = styled(Row)`
  padding-top: 5px;
  padding-bottom: 5px;
  strong {
    font-size: 16px;
  }
  .success {
    color: green;
  }
  .error {
    color: red;
  }
  .warning {
    color: orange;
  }
  .text-center {
    text-align: center;
  }
  .value {
    display: inline-block;
    padding: 0 0 0 5px;
  }
`